import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { browserHistory } from 'react-router'
import { selectUnitPreference } from 'services/user/selectors'
import { METERS, IMPERIAL, MILES, KILOMETERS, HOURS, SECONDS } from 'shared/units/constants'
import convert from 'shared/units/convert'
import styles from './_createGoalPage.css'
import * as goalActions from 'services/goals/actions'
import * as goals from 'services/goals/selectors'
import GoalsHeader from '../shared/GoalsHeader'
import CreateGoalForm from './CreateGoalForm'
import { GOAL_TYPES } from '../shared/constants'
import { AD_SIZES } from 'services/ads/constants'
import Ad from 'components/util/ads/Ad'

const mapStateToProps = (state) => ({
  unitPreference: selectUnitPreference(state),
  createGoalLoading: goals.selectCreateGoalLoading(state),
})

const mapDispatchToActions = {
  ...goalActions,
}

export class CreateGoalPage extends Component {
  static propTypes = {
    params: PropTypes.object,
    unitPreference: PropTypes.string,
    createGoal: PropTypes.func,
    createGoalLoading: PropTypes.bool,
    location: PropTypes.object,
    shouldSeeAds: PropTypes.bool,
    siteAbbr: PropTypes.string,
  }

  handleCreateGoalSubmit = (goal) => {
    const {
      params: {
        userId,
      },
      unitPreference: system } = this.props

    let convertedTarget = goal.target

    if (goal.type === GOAL_TYPES.duration.key) {
      convertedTarget = convert(goal.target).from(HOURS).to(SECONDS)
    } else if (goal.type === GOAL_TYPES.distance.key) {
      convertedTarget = convert(goal.target)
        .from(system === IMPERIAL ? MILES : KILOMETERS)
        .to(METERS)
    }

    this.props.createGoal(goal, userId, convertedTarget).then(() => {
      browserHistory.push(`/profile/${userId}/goals`)
    })
  }

  render () {
    const {
      unitPreference: system,
      createGoalLoading,
      location,
    } = this.props

    return (
      <Row>
        <Col xs={12} md={8}>
          <div className={styles.createGoalPage}>
            <GoalsHeader showCreateButton={false} />
            <CreateGoalForm
              isLoading={createGoalLoading}
              system={system}
              paramGoalType={location.query.data_type_field}
              paramTarget={location.query.target}
              onSubmit={this.handleCreateGoalSubmit} />
          </div>
        </Col>
        <Col xs={12} md={4}>
          <Ad sizes={[AD_SIZES.RAIL_3]} />
        </Col>
      </Row>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToActions)(CreateGoalPage)



// WEBPACK FOOTER //
// ./src/components/goals/create/CreateGoalPage.jsx